<template>
	<div class="innerBox">
		<h2 class="mb-4">Price List Asuransi</h2>
		
		<div class="mt-3 border border-danger" style="background-color: #1f2225;padding: 15px 15px;color:white;font-weight:bold;font-size:15px;overflow-x:auto">
            <div class="row">
                <div class="col-sm-5 row">
                    <div class="col-sm-5 col-xs-5 col-xs-5">
                        Nama Alias
                    </div>
                    <div class="col-sm-2 col-xs-2 col-xs-2">
                        :
                    </div>
                    <div class="col-sm-5 col-xs-5 col-xs-5" v-if="insuranceCompany">
						{{insuranceCompany.name}}
                    </div>
                </div>
                <div class="col-sm-1">
                </div>
                <div class="col-sm-5 row">
                    <div class="col-sm-5 col-xs-5 col-xs-5">
                        Nama Perusahaan
                    </div>
                    <div class="col-sm-2 col-xs-2 col-xs-2">
                        :
                    </div>
                    <div class="col-sm-5 col-xs-5 col-xs-5" v-if="insuranceCompany">
                        {{insuranceCompany.company_name}}
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-sm-5 row">
                    <div class="col-sm-5 col-xs-5 col-xs-5">
                        Alamat
                    </div>
                    <div class="col-sm-2 col-xs-2 col-xs-2">
                        :
                    </div>
                    <div class="col-sm-5 col-xs-5 col-xs-5" v-if="insuranceCompany">
                        {{insuranceCompany.address}}
                    </div>
                </div>
                <div class="col-sm-1">
                </div>
                <div class="col-sm-5 row">
                    <div class="col-sm-5 col-xs-5">
                        Nomor Telefon
                    </div>
                    <div class="col-sm-2 col-xs-2">
                        :
                    </div>
                    <div class="col-sm-5 col-xs-5" v-if="insuranceCompany">
                        {{insuranceCompany.phone_number}}
                    </div>
                </div>
            </div>
            
        </div>

		<div class="mt-3 text-right">
			<button
				class="btn btn-primary "
				@click="tambahPricelist()"
			>
				Tambah Price List
			</button>
		</div>

		
		<div class="row mt-1">
			<div class="col-12 col-md-3">
				<!-- <search
					:mobile="mobile"
                	@detail-of="detailOf"
				/> -->
				<h4>Kategori Harga Mobil</h4>
				<div class="w-100 mt-3" v-for="category in listInsuraceCarTypes" :key="category.id">
					<button
						class="btn w-100"
						:class="{'btn-outline-primary' : selected != category.id , 'btn-primary' : selected == category.id}"
						@click="selected = category.id"
					>
						{{category.name}} 
					</button>
				</div>

			</div>
			<div class="col-12 col-md-9 pl-4 pr-4" v-if="selected">
				<h3 class="text-center">Price List Details</h3>
				

				<div class="form-inline mt-4 mb-2">
					<label class="my-1 mr-2" for="inlineFormCustomSelectPref">Search :</label>
					<input type="text" class="form-control mb-2 mr-sm-2" id="inlineFormInputName2" style="width:40%" v-model="table.filter.search">
					<button class="btn btn-primary mb-2 mr-sm-2" type="button" style="width:20%" @click="table.update++">Search</button>
				</div> 
				<vue-universal-table
					
					class="mt-4"
					:data="priceListBrand"
					:fields="table.fields"
					:filter="table.filter"
					:buttons="table.buttons"
					:indexing="true"
					:api_url="'/api/v1/insurance/pricelist/' + this.selected"
					:update="table.update"
					:process_data="table.process_data"
					@onEdit="editPriceList"
					@onDelete="deletePriceList"
				></vue-universal-table>
			</div>
		</div>

		<!-- Modal Start -->
		<new-price-list
			v-if="modal.newPriceList"
			:insuranceCompanyId = "insuranceCompany.id"
			:category = "Object.assign([] , listInsuraceCarTypes)"
			@closeModal = "modal.newPriceList = false"
			@addSuccess="table.update++"
		></new-price-list>
		<edit-price-list
			v-if="modal.editPriceList"
			:insuranceCompanyId = "insuranceCompany.id"
			:data = "editData"
			:category = "selected"
			@closeModal = "modal.editPriceList = false"
			@editSuccess="table.update++"
		></edit-price-list>
		<!-- Modal End -->
		
	</div>
</template>

<script>
	import search from './children/search'

	import newPriceList from './children/newPriceList'
	import editPriceList from './children/editPriceList'

	export default {
		data () {
			return {
				modal : {
					newPriceList : false,
					editPriceList : false,
				},
				editData : null,
				carSelected : false,
				mobile: this.isMobile(),
				id: [],
				priceListBrand : null,
				insuranceCompany : null,
				productName : null,
				url : null,
				priceList : null,
				selected : null,
				table: {
					process_data : `
						for(var i = 0 ; i < data.length ; i++) {
							data[i].sparepart_variant_name = data[i].sparepart_variant_name.split('"').join("")
						}
					`,
					special_buttons : ['tambahPriceList'],
					filter: {
						insurance_company_id : '',
						search : ''
					},
					fields: [{
						title : 'Sparepart Name',
						variable : 'sparepart_variant_name'
					}, {
						title : 'Price',
						variable : 'price',
						number_formatting : true
					}, {
						title : 'Dibuat Pada',
						variable : 'created_at'
					}, {
						title : 'Terkahir Diubah',
						variable : 'updated_at'
					}],
					buttons : [
						{
							title : 'Edit',
							class : 'btn-outline-primary fas fa-edit'
						},
						{
							title : 'Delete',
							variable : 'id',
							class : 'btn-outline-danger fa fa-times'
						}
					],
					update : 0
				},
				listInsuraceCarTypes : null
			}
		},
		components : {
			search,
			newPriceList,
			editPriceList
		},
		mounted () {
			
			this.insuranceCompany = JSON.parse(this.$route.params.id)
			this.insuranceCompany = this.insuranceCompany.split('\n').join(' ')
			this.insuranceCompany = JSON.parse(this.insuranceCompany)
			this.table.filter.insurance_company_id = this.insuranceCompany.id

			this.loadCategoryCar()
		},
		watch : {
			selected : function () {
				this.table.update++;
				
			}
		},
		methods : {
			tambahPricelist () {
				// if(!this.selected) {
				// 	this.$store.dispatch('triggerAlert' , [false , 'Mohon Di Pilih Kategori Pricelist Terlebih Dahalu.'])
				// 	return
				// }

				this.modal.newPriceList = true
			},
			editPriceList (data) {
				console.log(data)
				this.editData = JSON.parse(data);
				this.modal.editPriceList = true;
			},
			deletePriceList (id) {
				this.$http.delete('/api/v1/insurance/pricelist/' + id)
				.then((resp) => {
					this.$store.dispatch('triggerAlert', [true, ['Pricelist telah berhasil dihapus']])
					this.table.update++;
				})
			},
			detailOf(obj , name) {
				// this.table.filter.car_id = obj
				this.table.filter.search = name
				this.productName = name
				this.table.update++;
			},
			loadCategoryCar () {
				this.$http.get('/api/v1/insurance/car')
				.then((resp) => {
					this.listInsuraceCarTypes = resp.data.data.sort((a,b) => a.id - b.id)
				})
				.catch((err) => {
					console.log(err)
				})
			}
		}
	}
</script>